document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const syncScrollState = () => {
    body.classList.toggle('is-scrolled', window.scrollY > 16);
  };

  syncScrollState();
  window.addEventListener('scroll', syncScrollState, { passive: true });

  const reveals = document.querySelectorAll('.js-reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });

    reveals.forEach((el) => observer.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-magnetic]').forEach((el) => {
    const strength = Number(el.dataset.magneticStrength || 16);
    let frame = null;
    let nextTransform = '';

    const apply = () => {
      frame = null;
      el.style.transform = nextTransform;
    };

    const queue = (transform) => {
      nextTransform = transform;
      if (frame === null) {
        frame = requestAnimationFrame(apply);
      }
    };

    const reset = () => {
      queue('');
    };

    el.addEventListener('pointermove', (event) => {
      const rect = el.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width - 0.5) * strength;
      const y = ((event.clientY - rect.top) / rect.height - 0.5) * strength;
      queue(`translate3d(${x}px, ${y}px, 0)`);
    });

    el.addEventListener('pointerleave', reset);
  });

  document.querySelectorAll('[data-fluid-hover]').forEach((el) => {
    let frame = null;
    let nextX = 50;
    let nextY = 50;

    const apply = () => {
      frame = null;
      el.style.setProperty('--fluid-x', `${nextX}%`);
      el.style.setProperty('--fluid-y', `${nextY}%`);
    };

    const queue = (event) => {
      const rect = el.getBoundingClientRect();
      nextX = clamp(((event.clientX - rect.left) / rect.width) * 100, 0, 100);
      nextY = clamp(((event.clientY - rect.top) / rect.height) * 100, 0, 100);

      if (frame === null) {
        frame = requestAnimationFrame(apply);
      }
    };

    const activate = (event) => {
      el.classList.add('is-fluid-active');
      if (event && event.clientX !== undefined) {
        queue(event);
      } else if (frame === null) {
        frame = requestAnimationFrame(apply);
      }
    };

    const reset = () => {
      el.classList.remove('is-fluid-active');
      if (frame !== null) {
        cancelAnimationFrame(frame);
        frame = null;
      }
      el.style.removeProperty('--fluid-x');
      el.style.removeProperty('--fluid-y');
    };

    el.addEventListener('pointerenter', activate);
    el.addEventListener('pointermove', queue);
    el.addEventListener('pointerleave', reset);
    el.addEventListener('focusin', activate);
    el.addEventListener('focusout', reset);
  });

  document.querySelectorAll('.premium-homepage__visual').forEach((section) => {
    const media = section.querySelector('.premium-homepage__visual-media');
    const card = section.querySelector('.premium-homepage__visual-card');

    if (!media) {
      return;
    }

    let frame = null;
    let nextX = 0;
    let nextY = 0;

    const apply = () => {
      frame = null;
      media.style.transform = `translate3d(${nextX * 12}px, ${nextY * 12}px, 0) scale(1.03)`;
      if (card) {
        card.style.transform = `translate3d(${nextX * -14}px, ${nextY * -10}px, 0)`;
      }
    };

    const queue = (event) => {
      const rect = section.getBoundingClientRect();
      nextX = (event.clientX - rect.left) / rect.width - 0.5;
      nextY = (event.clientY - rect.top) / rect.height - 0.5;

      if (frame === null) {
        frame = requestAnimationFrame(apply);
      }
    };

    section.addEventListener('pointermove', queue);
    section.addEventListener('pointerleave', () => {
      media.style.transform = '';
      if (card) {
        card.style.transform = '';
      }
      if (frame !== null) {
        cancelAnimationFrame(frame);
        frame = null;
      }
    });
  });
});
